/*
  KOM — Attribuzione caroselli
  ---------------------------------------------------------------
  Registra da quale carosello arriva un prodotto aggiunto al carrello e
  scrive la sorgente nell'attributo di carrello `carousel_sources`, che
  Shopify porta da se' nell'ordine. La pipeline lo rilegge dagli ordini.

  - Nessun beacon, nessun endpoint, nessun cookie: solo localStorage e
    gli attributi di carrello (contratto brief §3.3).
  - Sanificazione: solo [a-z0-9:_-], max 64 caratteri, max 5 sorgenti.
  - Difensivo per costruzione: qualsiasi errore qui non deve mai
    impedire un add-to-cart.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'kom_carousel_sources';
  var TTL         = 3 * 24 * 60 * 60 * 1000;   // finestra click-through: 3 giorni
  var MAX_SOURCES = 5;
  var VALID       = /^[a-z0-9:_-]{1,64}$/;
  var CTX_TTL     = 15000;                      // validita' del contesto ATC

  function routes() { return window.routes || {}; }
  function root()   { var r = (routes().root_url || '/'); return r === '/' ? '' : r.replace(/\/$/, ''); }
  function cartJs() { return root() + '/cart.js'; }
  function updateJs() { return routes().cart_update_url || (root() + '/cart/update.js'); }
  function valid(s) { return typeof s === 'string' && VALID.test(s); }

  /* ---------- memoria handle -> sorgente (3 giorni) ---------- */

  function readMemory() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      var map = JSON.parse(raw), now = Date.now(), out = {};
      Object.keys(map).forEach(function (h) {
        var e = map[h];
        if (e && typeof e.ts === 'number' && (now - e.ts) < TTL && valid(e.source)) out[h] = e;
      });
      return out;
    } catch (e) { return {}; }
  }

  function remember(handle, source) {
    if (!handle || !valid(source)) return;
    try {
      var map = readMemory();
      map[handle] = { source: source, ts: Date.now() };
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch (e) { /* quota piena o storage negato: si rinuncia in silenzio */ }
  }

  function recall(handle) {
    var e = readMemory()[handle];
    return e ? e.source : null;
  }

  /* ---------- helper DOM ---------- */

  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? m[1] : null;
  }

  function sourceOf(el) {
    var w = (el && el.closest) ? el.closest('[data-carousel-source]') : null;
    if (!w) return null;
    var s = w.getAttribute('data-carousel-source');
    return valid(s) ? s : null;
  }

  /* ---------- clic su un prodotto dentro un carosello ---------- */

  document.addEventListener('click', function (e) {
    try {
      var a = (e.target && e.target.closest) ? e.target.closest('a[href*="/products/"]') : null;
      if (!a) return;
      var src = sourceOf(a);
      if (!src) return;
      var h = handleFromHref(a.getAttribute('href'));
      if (h) remember(h, src);
    } catch (err) {}
  }, true);

  /* ---------- contesto dell'add-to-cart in corso ---------- */

  var pending = null;

  function captureContext(e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var form = t.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
      pending = {
        source: sourceOf(t),                                            // quick-add dentro un carosello
        handle: form ? form.getAttribute('data-product-handle') : null, // PDP
        ts: Date.now()
      };
    } catch (err) {}
  }

  document.addEventListener('submit', captureContext, true);
  document.addEventListener('click', captureContext, true);

  function resolveSource() {
    if (!pending || (Date.now() - pending.ts) > CTX_TTL) return null;
    if (valid(pending.source)) return pending.source;
    if (pending.handle) return recall(pending.handle);
    return null;
  }

  /* ---------- read-modify-write dell'attributo di carrello ---------- */

  function record(source) {
    if (!valid(source)) return;
    fetch(cartJs(), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return null;
        var current = (cart.attributes && cart.attributes.carousel_sources) || '';
        var list = current.split(',').map(function (s) { return s.trim(); }).filter(valid);
        if (list.indexOf(source) !== -1) return null;   // gia' attribuita: nessuna scrittura
        list.push(source);
        if (list.length > MAX_SOURCES) list = list.slice(0, MAX_SOURCES);
        return fetch(updateJs(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { carousel_sources: list.join(',') } })
        });
      })
      .catch(function () { /* l'attribuzione non deve mai rompere il carrello */ });
  }

  /* ---------- aggancio: il tema aggiunge al carrello con fetch() ---------- */

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  window.fetch = function (input, init) {
    var out = nativeFetch.apply(this, arguments);
    try {
      var url = (typeof input === 'string') ? input : ((input && input.url) || '');
      if (url.indexOf('/cart/add') !== -1) {
        out.then(function (res) {
          if (res && res.ok) {
            var s = resolveSource();
            if (s) record(s);
          }
        }).catch(function () {});
      }
    } catch (e) {}
    return out;   // la Promise originale resta intatta
  };
})();
